import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "hitha_owner_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  login: (password) => axios.post(`${API}/auth/login`, { password }).then((r) => r.data),
  verify: () => axios.get(`${API}/auth/verify`, { headers: authHeaders() }).then((r) => r.data),

  getRooms: () => axios.get(`${API}/rooms`).then((r) => r.data),
  updateRoom: (id, data) =>
    axios.put(`${API}/rooms/${id}`, data, { headers: authHeaders() }).then((r) => r.data),

  createBooking: (data) => axios.post(`${API}/bookings`, data).then((r) => r.data),
  listBookings: () =>
    axios.get(`${API}/bookings`, { headers: authHeaders() }).then((r) => r.data),
  deleteBooking: (id) =>
    axios.delete(`${API}/bookings/${id}`, { headers: authHeaders() }).then((r) => r.data),

  createContact: (data) => axios.post(`${API}/contact`, data).then((r) => r.data),
  listContacts: () =>
    axios.get(`${API}/contact`, { headers: authHeaders() }).then((r) => r.data),
  deleteContact: (id) =>
    axios.delete(`${API}/contact/${id}`, { headers: authHeaders() }).then((r) => r.data),

  getSettings: () => axios.get(`${API}/settings`).then((r) => r.data),
  updateSettings: (data) =>
    axios.put(`${API}/settings`, data, { headers: authHeaders() }).then((r) => r.data),

  // Reviews — public list
  listReviewsPublic: () => axios.get(`${API}/reviews`).then((r) => r.data),
  // Reviews — admin (all incl. unpublished)
  listReviewsAdmin: () =>
    axios.get(`${API}/admin/reviews`, { headers: authHeaders() }).then((r) => r.data),
  createReview: (data) =>
    axios.post(`${API}/reviews`, data, { headers: authHeaders() }).then((r) => r.data),
  updateReview: (id, data) =>
    axios.put(`${API}/reviews/${id}`, data, { headers: authHeaders() }).then((r) => r.data),
  deleteReview: (id) =>
    axios.delete(`${API}/reviews/${id}`, { headers: authHeaders() }).then((r) => r.data),
};
